import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/Index.vue'
import Login from '@/views/Login.vue'
import NotLoginHome from '@/views/NotLoginHome.vue'
import Register from '@/views/Register.vue'
import ForgetPassword from '@/views/forgetPassword.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch(err => err);
};

VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name === 'NavigationDuplicated') {
            return err;
        }
        throw err;
    });
};

const routes = [{
    path: '/login', name: 'login', component: Login
}, {
    path: '/', name: 'NotLoginHome', component: NotLoginHome
}, {
    path: '/register', name: 'register', component: Register
}, {
    path: '/forgetPassword', name: 'ForgetPassword', component: ForgetPassword
}, {
    path: '/index', name: 'Index', component: Index, redirect: "/teamList", children: [{
        path: "/home", name: "首页", component: () => import('@/views/Home.vue'), meta: {
            routeMenu: []
        },
    }, {
        path: "/joinCompetition", name: "项目填报", component: () => import('@/views/JoinCompetition.vue'), meta: {
            routeMenu: []
        },
    },

    {
        path: "/bmSummary", name: "报名汇总", component: () => import('@/views/bmhz/BmSummary.vue'), meta: {
            routeMenu: []
        },
    },

    {
        path: "/userList", name: "用户列表", component: () => import('@/views/user/UserList.vue'), meta: {
            routeMenu: []
        },
    }, {
        path: "/teamList", name: "代表队信息", component: () => import('@/views/team/TeamList.vue'), meta: {
            routeMenu: []
        },
    }, {
        path: "/addTeam", name: "新增代表队", component: () => import('@/views/team/AddTeam.vue'), meta: {
            routeMenu: [{
                name: "代表队信息", path: "/teamList",
            }]
        },
    }, {
        path: "/projectCategoryList",
        name: "项目分类列表",
        component: () => import('@/views/projectCategory/ProjectCategoryList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addProjectCategory",
        name: "编辑项目分类",
        component: () => import('@/views/projectCategory/AddProjectCategory.vue'),
        meta: {
            routeMenu: [{
                path: "/projectCategoryList", name: "项目分类列表"
            }]
        },
    }, {
        path: "/addProjectCategoryChild",
        name: "新增项目分类",
        component: () => import('@/views/projectCategory/AddProjectCategoryChild.vue'),
        meta: {
            routeMenu: [{
                path: "/projectCategoryList", name: "项目分类列表"
            }]
        },
    }, {
        path: "/paymentList", name: "费用列表", component: () => import('@/views/payment/PaymentList.vue'), meta: {
            routeMenu: []
        },
    }, {
        path: "/addPayment", name: "新增费用", component: () => import('@/views/payment/AddPayment.vue'), meta: {
            routeMenu: [{
                path: "/paymentList", name: "费用列表"
            }]
        },
    }, {
        path: "/competitionList",
        name: "赛事列表",
        component: () => import('@/views/competition/CompetitionList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addCompetition",
        name: "新增赛事",
        component: () => import('@/views/competition/AddCompetition.vue'),
        meta: {
            routeMenu: [{
                name: "赛事列表", path: "/competitionList",
            }]
        },
    }, {
        path: "/reviewCompetition",
        name: "审核赛事",
        component: () => import('@/views/competition/ReviewCompetition.vue'),
        meta: {
            routeMenu: [{
                name: "赛事列表", path: "/competitionList",
            }]
        },
    }, {
        path: "/athleteList",
        name: "运动员列表",
        component: () => import('@/views/athlete/AthleteList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addAthlete", name: "新增运动员", component: () => import('@/views/athlete/AddAthlete.vue'), meta: {
            routeMenu: [{
                name: "运动员列表", path: "/athleteList",
            }]
        },
    }, {
        path: "/announcementList",
        name: "公告列表",
        component: () => import('@/views/announcement/AnnouncementList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addAnnouncement",
        name: "新增公告",
        component: () => import('@/views/announcement/AddAnnouncement.vue'),
        meta: {
            routeMenu: [{
                name: "公告列表", path: "/announcementList",
            }]
        },
    }, {
        path: "/attachmentList",
        name: "下载中心",
        component: () => import('@/views/attachment/AttachmentList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addAttachmentTeam",
        name: "上传队伍资料",
        component: () => import('@/views/attachment/AddAttachmentTeam.vue'),
        meta: {
            routeMenu: [{
                name: "文件列表", path: "/attachmentList",
            }]
        },
    }, {
        path: "/addAttachmentCompetition",
        name: "上传赛事资料",
        component: () => import('@/views/attachment/AddAttachmentCompetition.vue'),
        meta: {
            routeMenu: [{
                name: "文件列表", path: "/attachmentList",
            }]
        },
    },

    {
        path: "/userNumTj", name: "人数统计", component: () => import('@/views/homeFile/UserNumTj.vue'), meta: {
            routeMenu: []
        },
    }, {
        path: "/ageCategoryList",
        name: "年龄组别列表",
        component: () => import('@/views/ageCategory/AgeCategoryList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addAgeCategory",
        name: "新增年龄组别",
        component: () => import('@/views/ageCategory/AddAgeCategory.vue'),
        meta: {
            routeMenu: [{
                path: "/ageCategoryList", name: "年龄组别列表"
            }]
        },
    },

    {
        path: "/competitionList",
        name: '赛事管理',
        component: () => import('@/views/competition/CompetitionList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: '/addUser', name: '新增用户', component: () => import('@/views/user/AddUser.vue'), meta: {
            routeMenu: [{ path: '/userList', name: '用户列表', }]
        },
    }, {
        path: "/userInfo", name: "个人资料", component: () => import('@/views/UserInfoPage.vue'), meta: {
            routeMenu: []
        },
    }, {
        path: "/teamStatistic",
        name: "代表队名单",
        component: () => import('@/views/teamStatistic/TeamStatistic.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/jtbianPai",
        name: "集体编排",
        component: () => import('@/views/teamStatistic/JtbianPai.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/tlbianPai",
        name: "套路编排",
        component: () => import('@/views/teamStatistic/TlbianPai.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/ageCategorySortConfig",
        name: "年龄组别顺序配置",
        component: () => import('@/views/AgeCategorySortConfig/AgeCategorySortConfig.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addAgeCategorySortConfig",
        name: "新增年龄组别顺序配置",
        component: () => import('@/views/AgeCategorySortConfig/AddAgeCategorySortConfig.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/projectCategorySortConfig",
        name: "项目类别顺序配置",
        component: () => import('@/views/ProjectCategorySortConfig/ProjectCategorySortConfig.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addProjectCategorySortConfig",
        name: "新增项目类别顺序配置",
        component: () => import('@/views/ProjectCategorySortConfig/AddProjectCategorySortConfig.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addressSetConfig",
        name: "场地分配",
        component: () => import('@/views/teamStatistic/AddressSetConfig.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/addressList",
        name: "场地分配表",
        component: () => import('@/views/teamStatistic/AddressList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/competitionDataList",
        name: "竞赛日程表",
        component: () => import('@/views/teamStatistic/CompetitionDataList.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/exportConfig",
        name: "项目导出排版",
        component: () => import('@/views/config/exportConfig.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/formatAdjustment",
        name: "数据格式调整",
        component: () => import('@/views/config/formatAdjustment.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/medalConfig",
        name: "奖牌统计",
        component: () => import('@/views/medalcount/medalConfig.vue'),
        meta: {
            routeMenu: []
        },
    }, {
        path: "/exportSettings",
        name: "编排权限设置",
        component: () => import('@/views/attachment/ExportSettings.vue'),
        meta: {
            routeMenu: []
        },
    },]
}]

const router = new VueRouter({
    mode: 'history', // 从hash模式切换为history模式
    routes
})

export default router
